// utils/caAgencies.js — California State Agencies with SCO codes
// Source: State Controller's Office agency code list
// Format: { name, code, abbreviation, category }

export const CA_AGENCIES = [
  // Control Agencies
  { name: 'Department of Finance', code: '0840', abbr: 'DOF', category: 'Control Agency' },
  { name: 'Department of General Services', code: '0690', abbr: 'DGS', category: 'Control Agency' },
  { name: 'State Controller Office', code: '0840', abbr: 'SCO', category: 'Control Agency' },
  { name: 'Department of Human Resources', code: '0845', abbr: 'CalHR', category: 'Control Agency' },

  // Natural Resources
  { name: 'California Department of Forestry and Fire Protection', code: '3540', abbr: 'CAL FIRE', category: 'Natural Resources' },
  { name: 'Department of Fish and Wildlife', code: '3600', abbr: 'CDFW', category: 'Natural Resources' },
  { name: 'Department of Parks and Recreation', code: '3790', abbr: 'DPR', category: 'Natural Resources' },
  { name: 'Department of Water Resources', code: '3860', abbr: 'DWR', category: 'Natural Resources' },
  { name: 'State Lands Commission', code: '3560', abbr: 'SLC', category: 'Natural Resources' },
  { name: 'Delta Stewardship Council', code: '3537', abbr: 'DSC', category: 'Natural Resources' },
  { name: 'Wildlife Conservation Board', code: '3640', abbr: 'WCB', category: 'Natural Resources' },

  // Energy & Environment
  { name: 'Office of Energy Infrastructure Safety', code: '3355', abbr: 'Energy Safety', category: 'Energy & Environment' },
  { name: 'California Energy Commission', code: '3360', abbr: 'CEC', category: 'Energy & Environment' },
  { name: 'California Public Utilities Commission', code: '8660', abbr: 'CPUC', category: 'Energy & Environment' },
  { name: 'Department of Toxic Substances Control', code: '3940', abbr: 'DTSC', category: 'Energy & Environment' },
  { name: 'State Air Resources Board', code: '3900', abbr: 'CARB', category: 'Energy & Environment' },
  { name: 'State Water Resources Control Board', code: '3940', abbr: 'SWRCB', category: 'Energy & Environment' },
  { name: 'Office of Environmental Health Hazard Assessment', code: '3980', abbr: 'OEHHA', category: 'Energy & Environment' },

  // Transportation
  { name: 'Department of Transportation', code: '2660', abbr: 'Caltrans', category: 'Transportation' },
  { name: 'Department of Motor Vehicles', code: '2740', abbr: 'DMV', category: 'Transportation' },
  { name: 'California Highway Patrol', code: '2720', abbr: 'CHP', category: 'Transportation' },
  { name: 'High-Speed Rail Authority', code: '2665', abbr: 'CHSRA', category: 'Transportation' },

  // Health & Human Services
  { name: 'Department of Health Care Services', code: '4260', abbr: 'DHCS', category: 'Health & Human Services' },
  { name: 'Department of Public Health', code: '4265', abbr: 'CDPH', category: 'Health & Human Services' },
  { name: 'Department of Social Services', code: '5180', abbr: 'CDSS', category: 'Health & Human Services' },
  { name: 'Department of Developmental Services', code: '4300', abbr: 'DDS', category: 'Health & Human Services' },
  { name: 'Department of State Hospitals', code: '4440', abbr: 'DSH', category: 'Health & Human Services' },
  { name: 'Department of Aging', code: '4170', abbr: 'CDA', category: 'Health & Human Services' },
  { name: 'Department of Rehabilitation', code: '5160', abbr: 'DOR', category: 'Health & Human Services' },

  // Corrections & Justice
  { name: 'Department of Corrections and Rehabilitation', code: '5225', abbr: 'CDCR', category: 'Corrections & Justice' },
  { name: 'Department of Justice', code: '0820', abbr: 'DOJ', category: 'Corrections & Justice' },
  { name: 'Board of State and Community Corrections', code: '5227', abbr: 'BSCC', category: 'Corrections & Justice' },

  // Business & Consumer Services
  { name: 'Department of Consumer Affairs', code: '1111', abbr: 'DCA', category: 'Business & Consumer Services' },
  { name: 'Department of Business Oversight', code: '1701', abbr: 'DFPI', category: 'Business & Consumer Services' },
  { name: 'Department of Financial Protection and Innovation', code: '1701', abbr: 'DFPI', category: 'Business & Consumer Services' },
  { name: 'Department of Industrial Relations', code: '8350', abbr: 'DIR', category: 'Business & Consumer Services' },
  { name: 'Department of Food and Agriculture', code: '8570', abbr: 'CDFA', category: 'Business & Consumer Services' },

  // Education
  { name: 'Department of Education', code: '6110', abbr: 'CDE', category: 'Education' },
  { name: 'California Community Colleges', code: '6870', abbr: 'CCCCO', category: 'Education' },
  { name: 'Student Aid Commission', code: '6980', abbr: 'CSAC', category: 'Education' },

  // Technology & Innovation
  { name: 'Department of Technology', code: '0540', abbr: 'CDT', category: 'Technology' },
  { name: 'Office of Data and Innovation', code: '0549', abbr: 'ODI', category: 'Technology' },

  // Labor & Workforce
  { name: 'Employment Development Department', code: '7100', abbr: 'EDD', category: 'Labor & Workforce' },
  { name: 'Labor and Workforce Development Agency', code: '8350', abbr: 'LWDA', category: 'Labor & Workforce' },

  // Veterans & Military
  { name: 'Department of Veterans Affairs', code: '8955', abbr: 'CalVet', category: 'Veterans & Military' },
  { name: 'Military Department', code: '8940', abbr: 'CalGuard', category: 'Veterans & Military' },

  // Housing
  { name: 'Department of Housing and Community Development', code: '2240', abbr: 'HCD', category: 'Housing' },
  { name: 'California Housing Finance Agency', code: '2240', abbr: 'CalHFA', category: 'Housing' },

  // Other
  { name: 'Governor\'s Office', code: '0500', abbr: "Gov's Office", category: 'Executive' },
  { name: 'Legislature', code: '0010', abbr: 'Legislature', category: 'Legislative' },
  { name: 'Judicial Council of California', code: '0250', abbr: 'JCC', category: 'Judicial' },
];

// Group by category for dropdown display
export const AGENCIES_BY_CATEGORY = CA_AGENCIES.reduce((acc, agency) => {
  if (!acc[agency.category]) acc[agency.category] = [];
  acc[agency.category].push(agency);
  return acc;
}, {});

// Quick lookup by name
export const AGENCY_BY_NAME = CA_AGENCIES.reduce((acc, agency) => {
  acc[agency.name] = agency;
  return acc;
}, {});
